import React, { useState, Fragment, useEffect } from "react";
import { Box, Card, Input, TextField, Button } from "@mui/material";
import clss from "./MFregiApp.module.css";
import RegiForm from "./RegiForm";
import { useLocation, useNavigate } from "react-router-dom";

const MFregiApp = (props) => {
  const [showmain, setShowmain] = useState(false); // 메인화면 표시여부
  const [dstitle, setDstitle] = useState(""); // 선택된 재난정보 제목
  const [nData, setNData] = useState([]); // 활동중인 재난정보 리스트
  const [rfshData, setRfshData] = useState(""); // 갱신요청 변수
  const [showIdInput, setShowIdInput] = useState(false); // ID 입력 화면 표시 여부
  const [inputId, setInputId] = useState(""); // 입력받은 ID 저장

  // URL 쿼리 파라미터 가져오기
  const location = useLocation();
  const qrs = location.search;
  const params = new URLSearchParams(qrs);
  const [id, setId] = useState(params.get("id")); // id를 state로 변경

  const apiAddr = props.apiAddr;
  const navigate = useNavigate();

  // ID 입력 처리 함수
  const handleIdSubmit = () => {
    if (inputId.trim() === "") {
      alert("ID를 입력해주세요.");
      return;
    }
    setId(inputId); // 입력받은 ID를 설정
    setShowIdInput(false); // ID 입력 화면 숨기기
    setRfshData((prev) => prev + 1); // useEffect 재실행 트리거
  };

  useEffect(() => {
    if (id == "undefined" || !id) {
      //alert("비정상적인 접근입니다.");
      setShowIdInput(true); // ID 입력 화면 표시
      return;
    }
    const getid = async () => {
      // 등록사용자 정보저장
      const wstring = `${apiAddr}/get/getid?id=${id}`;
      //const wstring = `https://map.119survey.org/nodetodb/get/getid?id=${id}`;
      //const wstring = `http://localhost:8080/get/getid?id=${id}`;
      console.log(wstring);
      const response = await fetch(wstring);
      const responseData = await response.json();
      console.log(responseData);

      // responseData를 localStorage에 저장
      localStorage.setItem("userData", JSON.stringify(responseData));

      // 회신데이터가 없으면 중지
      if (responseData.length === 0) {
        alert("등록되지 않은 사용자입니다.");
        setShowIdInput(true); // ID 입력 화면 표시
        return;
      } else {
        // 회신데이터가 있으면(정상적인 접속이면)
        // fc_status 값이 있는지 확인 즉 강원소방접속인지?
        if (responseData[0].fc_status) {
          // 기본사용자 정보 세션에 저장
          console.log("강원소방으로 로그인");
          responseData.map((item) => {
            sessionStorage.reg_org = item.fc_org_nm;
            sessionStorage.reg_dpt = item.fc_dpt_nm;
            sessionStorage.reg_rank = item.i_rank;
            sessionStorage.reg_name = item.i_name;
            sessionStorage.reg_pnum = item.i_mphone;
            sessionStorage.reg_status = item.fc_status;
          });
          const hq = "gw";
          getActiveDSlist(hq); // 활동중인 재난목록 가져오기 호출
        } else {
          console.log("타 소방으로 로그인");
          const hq = responseData[0].hq;
          getActiveDSlist(hq); // 활동중인 재난목록 가져오기 호출
        }
      }
    };
    getid();

    const getActiveDSlist = async (hq) => {
      // 활동중인 재난정보 가져오기
      //const wstring = `${apiAddr}/get/getactivedslist`;
      const wstring = `${apiAddr}/get/getactivedslist?hq=${hq}`; // URL에 hq 파라미터 추가
      console.log(wstring);
      const response = await fetch(wstring);
      const responseData = await response.json();
      console.log(responseData);
      setNData(responseData);
    };
    // getActiveDSlist();
  }, [rfshData, id]); // id를 의존성 배열에 추가

  const dsselecHandler = (item) => () => {
    let ox = window.confirm("선택하신 재난의 자원등록을 하시겠습니까?");
    if (ox) {
      console.log(item.dsnm);
      sessionStorage.selectedDSname = item.dsnm;
      sessionStorage.selectedDSnum = item.snum;
      sessionStorage.selectedDSid = item.dsnum;
      sessionStorage.ondsid = item.dsnum;
      // setSelectedDS(true);
      setDstitle(item.dsnm);
      setShowmain(true);
    }
  };

  const nactvdslist = nData.map((item) => (
    // console.log(item.dsnm);
    <div
      style={{ cursor: "pointer" }}
      key={Math.random()}
      className={clss.dslisitem}
      onClick={dsselecHandler(item)}
    >
      <h3>{item.dsnm.trim()}</h3>
      <div style={{ fontSize: "1rem" }}>{item.dsaddr.trim()}</div>
      <div style={{ fontSize: "1rem" }}>{item.dsipdt.trim()}</div>
    </div>
  ));

  const btnClickHandler = () => {
    console.log(id);
  };

  const refreshDSHandler = (e) => {
    let ox = window.confirm("다른 재난을 선택하시겠습니까?");
    if (ox) {
      // setSelectedDS(false);
      setShowmain(false);
      setRfshData(Math.random()); // 재난선택화면 갱신
    }
  };

  const mobileLayoutSx = {
    maxWidth: 480,
    width: "100%",
    margin: "0 auto",
    height: "100vh",
    minHeight: "100vh",
    boxSizing: "border-box",
    overflowX: "hidden",
    overflowY: "auto",
    px: { xs: 0, sm: 1 },
  };

  return (
    <Fragment>
      <Box sx={mobileLayoutSx}>
      {showIdInput ? (
        // ID 입력 화면
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            p: 3,
            maxWidth: 400,
            margin: "auto",
            marginTop: 5,
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
          }}
        >
          <div
            className={clss.intitle}
            style={{
              width: "100%",
              textAlign: "center",
              background: "none",
              color: "#ff9800",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
              fontSize: "1.8rem",
              fontWeight: "bold",
              padding: "10px 0",
            }}
          >
            자원등록앱
          </div>
          <h2>ID 입력</h2>
          <TextField
            fullWidth
            label="아이디를 입력하세요"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            onClick={handleIdSubmit}
            sx={{
              backgroundColor: "#ff9800",
              "&:hover": {
                backgroundColor: "#f57c00",
              },
              width: "100%",
              padding: "10px 50px",
              fontSize: "1.1rem",
              margin: "10px 0",
            }}
          >
            확인
          </Button>
        </Box>
      ) : (
        <>
          {!showmain && (
            <>
              <div className={clss.intitle}>자원등록앱</div>
              <p
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  textAlign: "center",
                  margin: "10px",
                  padding: "10px",
                  backgroundColor: "lightgray",
                }}
              >
                동원자원관리시스템에서 각 기관으로부터 동원된 자원을
                등록관리하는 앱입니다. 지정된 사용자가 아니면 사용을 중단합니다.
                <br />
                <br />
                아래 목록에서 등록하고자 하는 재난을 선택하세요
              </p>
              <div className={clss.titlerow}>
                <ul
                  style={{
                    listStyle: "none",
                    padding: "0px",
                    margin: "0px",
                    width: "70%",
                  }}
                >
                  <div
                    key="qrattendmgr-btn"
                    className={clss.dslisitem}
                    style={{ cursor: "pointer", borderColor: "green" }}
                    onClick={() => navigate("/qrattend-scanner")}
                  >
                    <h3>지원인력 QR 출퇴근 관리</h3>
                  </div>
                  {nactvdslist}
                </ul>
              </div>
            </>
          )}
          {showmain && (
            <RegiForm
              apiAddr={apiAddr}
              btnClickHandler={btnClickHandler}
              plusBtnClickHandler={props.plusBtnClickHandler}
              dstitle={dstitle}
              refreshDSHandler={refreshDSHandler}
            />
          )}
        </>
      )}
      </Box>
    </Fragment>
  );
};

export default MFregiApp;
